import * as formats from './formats.js';

// 実費処理
$(() => {
    // 初期実行
    if ($('#js-regist-invoice-content, #js-register-payment') != null) {
        addRemoveButton();
    }

    //実費>行追加
    $(document).on("click", '.js-add-invoice-content, .js-add-payment-content', function(e) {
        e.preventDefault();
        let template = $(this).parent().parent().find('.js-dynamic-row-content').find('.js-dynamic-row').last();
        let row = template.clone();
        let newId = row.data('id') + 1;
        row.attr('data-id', newId);
        row.find('input').each(function(){
            // valueの初期化
            $(this).val('');
        });
        template.after(row);
        addRemoveButton();
    });

    //実費>行削除
    $(document).on("click", '.js-remove-row', function(e) {
        e.preventDefault();
        let delTargets = $(this).parent().parent().parent().find('.js-remove-row');
        let row = $(this).parents('.js-dynamic-row');
        if (delTargets.length > 1) {
            row.remove();
        } else {
            row.find('input').each(function(){
                // valueの初期化
                $(this).val('');
            });
        }
        fetchCostToContent();
        updateTotalPrice();
    });

    // 実費>数量に1を設定 (「経費・交通費」+ 数値入力検出)
    $(document).on("input", '.js-unit-price-tax-excluded', function(e) {
        const $row = $(this).closest('.js-dynamic-row'); // 行全体を取得
        const itemValue = $row.find('.js-invoice-content-item').val().trim(); // item の値を取得
        const unitPriceValue = parseFloat($(this).val().replace('¥', '').replaceAll(',', '')); // 数値化
        const quantityField = $row.find('.js-quantity');

        // 条件: item が「経費・交通費」かつ unitPriceValue が有効な数値かつ 0より大きい
        if (itemValue === '経費・交通費') {
            if (!isNaN(unitPriceValue) && unitPriceValue > 0) {
                quantityField.val(1); // 数量を1に設定
            } else {
                // `unitPriceValue` が空なら `quantity` も空にする
                quantityField.val('');
            }
        }
    });

    // 単価 税込価格更新
    $(document).on("focusout", '.js-unit-price-tax-excluded', function(e) {
        let result = parsePriceText($(this).val());
        // 控除の場合は「-」を取り除く
        if ($(this).parent().parent().find('input[name="invoice_content[item][]"], input[name="payment_content[item][]"]').val().indexOf('控除') > -1) {
            result = Math.abs(result);
            let val = result == 0 ? '¥0' : formats.convertPrice(formats.convertNum(result));
            $(this).val(val);
        }

        if (isNaN(result)) {
            $(this).val('');
        }
        let $row = $(this).parent().parent();
        updateUnitPriceTaxIncluded($row);
        updateTotalPrice();
    });

    // 税率 税込価格更新
    $(document).on("change", '.js-tax-rate', function(e) {
        let $row = $(this).parent().parent();
        updateUnitPriceTaxIncluded($row);
        updateTotalPrice();
    });

    // 数量 税込価格更新
    $(document).on("focusout", '.js-quantity', function(e) {
        let result = Number($(this).val());
        if (isFinite(result)) {
            let $row = $(this).parent().parent();
            updateUnitPriceTaxIncluded($row);
            updateTotalPrice();
        } else {
            $(this).val('');
        }
    });

    // 備考は5行目以上入力させない
    $(document).on("keyup", '.js-memo', function(e) {
        let lines = $(this).val().split("\n");
        // 入力行数が制限を超えた場合
        if (lines.length > 5) {
            let result = "";
            for (var i = 0; i < 5; i++) {
            result += lines[i] + "\n";
            }
            $(this).val(result);
        }
    });

    // 立替費精算書の値を反映
    if ($('#js-regist-invoice-cost').length !== 0) {
        fetchCostToContent();
        updateTotalPrice();

        $(document).on("focusout", '.js-cost-price', function(e) {
            fetchCostToContent();
            updateTotalPrice();
        });
    }

    showPriceDiffFromReportModal();
});

// 税込価格更新
function updateUnitPriceTaxIncluded($row)
{
    let excluded = parseFloat($row.find('.js-unit-price-tax-excluded').val().replace('¥', '').replaceAll(',', ''));
    let val_quantity = $row.find('.js-quantity').val();
    let quantity = Number(val_quantity);
    let item = $row.find('.js-item').text();
    if (!isNaN(excluded)) {
        let base;
        let is_minus = false;
        if (isFinite(quantity) && quantity > 0) {
            if (excluded < 0) {
                excluded = excluded * -1;
                is_minus = true;
            }
            // それぞれの小数点の位置を取得
            let dotPosition1 = getDotPosition(quantity);
            let dotPosition2 = getDotPosition(excluded);

            // 位置の値が大きい方（小数点以下の位が多い方）の位置を取得
            const max = Math.max(dotPosition1,dotPosition2);

            // 大きい方に小数の桁を合わせて文字列化、
            // 小数点を除いて整数の値にする
            let intValue1 = parseInt((quantity.toFixed(max) + '').replace('.', ''));
            let intValue2 = parseInt((excluded.toFixed(max) + '').replace('.', ''));

            // 10^N の値を計算
            let power = Math.pow(10,max);

            // 整数値で引き算した後に10^Nで割る
            base = Math.floor((intValue1 * intValue2) / power / power);
        } else {
            // 数量ゼロ
            base = 0;
        }
        if (item.indexOf('控除') > -1 || is_minus === true) {
            base = -base;
        }
        let val = base == 0 ? '¥0' : formats.convertPrice(formats.convertNum(base));
        $row.find('.js-unit-price-tax-included').val(val);
        $row.find('.js-unit-price-tax-included-hidden').val(base);
    } else {
        $row.find('.js-unit-price-tax-included').val('¥0');
        $row.find('.js-unit-price-tax-included-hidden').val('');
    }
}

function updateTotalPrice()
{
    const $content = $('#js-regist-invoice-content, #js-regist-payment-content');
    let $prices = $content.find('.js-unit-price-tax-included');
    let $taxes = $content.find('.js-tax-rate');
    let items = $content.find('.js-invoice-content-item, .js-payment-content-item');
    let taxable_total = 0;
    let taxable_total_map = {
        8: [],
        10: []
    };
    let subtotal = 0;
    let tax = 0;
    let tax_details = {};
    let withholding = 0;
    let expense = 0;
    let is_tax_type_included = $('input[name=is_tax_type_included]').val();
    $prices.each(function(index){
        let price = parsePriceText($(this).val());
        if ($(items[index]).val() === '経費・交通費') {
            expense += price;
        } else {
            let tax_rate = parseFloat($($taxes[index]).val());
            if (!isNaN(price)){
                subtotal += price;
                if (tax_rate) {
                    taxable_total_map[tax_rate].push(price);
                    taxable_total += price;
                }
            }
        }
    });
    Object.keys(taxable_total_map).forEach(tax_rate => {
        let total_per_rate = taxable_total_map[tax_rate].reduce((sum, element) => {
            return sum + element;
        }, 0);
        let tax_per_rate;
        if (is_tax_type_included) {
            tax_per_rate = Math.floor(total_per_rate / (1 + tax_rate / 100) * (tax_rate / 100));
        } else {
            tax_per_rate = Math.floor(total_per_rate * tax_rate / 100);
        }
        tax += tax_per_rate;
        tax_details[tax_rate] = {
            tax: tax_per_rate,
            tax_excluded: total_per_rate,
        };
    });
    let $withholding;
    if ($('#js-price-withholding').length !== 0) {
        $withholding = $('#js-price-withholding');
        const $with_tax = $('#js-price-withholding.js-with-tax');
        let with_tax = $with_tax.length === 0 ? 0 : tax;
        let withholding_total;
        if (is_tax_type_included) {
            withholding_total = taxable_total;
            // 源泉徴収税抜の場合は合計から税を引いてから源泉徴収を計算させる
            if ($with_tax.length === 0) {
                withholding_total -= tax;
            }
        } else {
            withholding_total = (taxable_total + with_tax);
        }
        if (withholding_total <= 1000000) {
            withholding -= Math.floor(withholding_total * 10.21 / 100);
        } else {
            withholding -= Math.floor((withholding_total - 1000000) * 20.42 / 100 + 102100);
        }
        $withholding.text(formats.convertPrice(formats.convertNum(withholding)));
    }
    if (is_tax_type_included) {
        subtotal -= tax;
    }
    let total = subtotal + tax + withholding + expense;
    $('#js-price-total').text(formats.convertPrice(formats.convertNum(total)));
    $('#js-price-subtotal').text(formats.convertPrice(formats.convertNum(subtotal)));
    if (10 in tax_details) {
        $('#js-price-tax-10-tax-excluded').text(formats.convertPrice(formats.convertNum(tax_details[10]['tax_excluded'])));
        $('#js-price-tax-10-tax').text(formats.convertPrice(formats.convertNum(tax_details[10]['tax'])));
    }
    if (8 in tax_details) {
        $('#js-price-tax-8-tax-excluded').text(formats.convertPrice(formats.convertNum(tax_details[8]['tax_excluded'])));
        $('#js-price-tax-8-tax').text(formats.convertPrice(formats.convertNum(tax_details[8]['tax'])));
    }
    $('#js-price-expense').text(formats.convertPrice(formats.convertNum(expense)));
}

// 行の削除ボタン表示
function addRemoveButton()
{
    $('.js-dynamic-row').on({
        'mouseenter' : function() {
            $(this).find('.js-remove-row').show();
        },
        'mouseleave' : function(){
            $(this).find('.js-remove-row').hide();
        }
    });
}

function getDotPosition(value){

    // 数値のままだと操作できないので文字列化する
    const strVal = String(value);
    let dotPosition = 0;

    //　小数点が存在するか確認
    if(strVal.lastIndexOf('.') === -1){
        // 小数点があったら位置を取得
        dotPosition = (strVal.length-1) - strVal.lastIndexOf('.');
    }

    return dotPosition;
}

// 立替日の合計を請求情報に反映
function fetchCostToContent() {
    const $content = $('#js-regist-invoice-content');
    let $items = $content.find('.js-invoice-content-item');
    let $quantities = $content.find('.js-quantity');
    let $unit_prices = $content.find('.js-unit-price-tax-excluded');
    let $prices = $content.find('.js-unit-price-tax-included');
    let $hidden_prices = $content.find('.js-unit-price-tax-included-hidden');

    $items.each(function (index, item) {
        if($(item).val() == '経費・交通費') {
            const cost_quantity = getCostQuantity();
            const cost_total = getCostTotal();
            const formatted_cost_total = cost_total == 0 ? '¥0' : formats.convertPrice(cost_total);

            // 数量を更新
            let $quantity = $($quantities[index]);
            if (cost_quantity) {
                $quantity.val(cost_quantity);
                $($quantity.prev()).val(cost_quantity);
            }

            // 単価と金額を更新
            if (cost_total && formatted_cost_total) {
                let $unit_price = $($unit_prices[index]);
                $unit_price.val(formatted_cost_total);
                $($unit_price.prev()).val(cost_total);

                $($prices[index]).val(formatted_cost_total);
                $($hidden_prices[index]).val(cost_total);
            }
        }
    })
}

function getCostQuantity() {
    if($('.js-cost-price').length > 0) {
        return 1;
    } else {
        return null;
    }
}

// 立替費精算書から合計を取得
function getCostTotal() {
    let sum = 0;
    $('.js-cost-price').each(function(_, input) {
        let price = parsePriceText($(input).val()) || 0;
        sum = sum + Number(price);
    });
    return sum;
}

// テキスト形式の金額を数字に変換
function parsePriceText(text) {
    return parseFloat(text.replace('¥', '').replaceAll(',', ''));
}

// 業務報告書と請求書の合計税込金額に乖離がある場合にモーダル表示
function showPriceDiffFromReportModal()
{
    if (document.getElementById('partner-invoice-form') != null || document.getElementById('agent-invoice-form') != null) {
        if (document.getElementById('diff_from_report_modal') != null
            && $('input[name="has_price_diff_from_report"]').val() == 1) {
            $('#diff_from_report_modal').modal('show');
        }
    }
}
